import { createFileRoute } from '@tanstack/react-router'

import ForgotPassword from '@/features/Auth/ForgotPassword'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_public/forgot-password')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <ForgotPassword />
}
